<template>
  <v-dialog v-model="$store.state.appointmentsCalendarStore.appointmentsSelectedDayPage.confirmDeleteDialog" max-width="390">
    <v-card>
      <v-card-title class="headline error white--text"> Are you sure? </v-card-title>

      <v-card-text class="mt-6 mb-2 subtitle-1">
        All open slots for <strong>{{ formatDate(selectedDate) }}</strong> will be deleted</v-card-text
      >

      <hr />
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="darken-1" text @click="closeDialog()"> Cancel </v-btn>

        <v-btn color="error" class="elevation-0" @click="deleteSlots()" :disabled="loading" :loading="loading"> Yes </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      loading: false
    };
  },
  computed: {
    selectedDate() {
      return this.$store.state.appointmentsCalendarStore.appointmentsSelectedDayPage.selectedDate;
    },
    locationSelected() {
      return this.$store.state.appointmentsCalendarStore.locationSelected;
    }
  },
  methods: {
    closeDialog() {
      this.$store.commit('appointmentsCalendarStore/SET_CONFIRM_DELETE_SLOTS_DIALOG', false);
    },
    deleteSlots() {
      let selectedDate = this.$store.state.appointmentsCalendarStore.appointmentsSelectedDayPage.selectedDate;
      this.loading = true;
      this.$store
        .dispatch('appointmentsCalendarStore/clearTimeSlot', {
          minDate: selectedDate,
          maxDate: selectedDate,
          locationId: this.locationSelected.id
        })
        .then((result) => {
          this.loading = false;
          if (result) {
            this.closeDialog();
            this.$store.dispatch('appointmentsCalendarStore/getCalenderDaySlots', {
              minDate: selectedDate,
              maxDate: selectedDate,
              locationId: this.locationSelected.id
            });
          }
        });
    },
    formatDate(d) {
      return moment(d, 'YYYY-MM-DD').format('DD-MMM-YYYY');
    }
  }
};
</script>

<style>
</style>
